// extracted by mini-css-extract-plugin
export default {"SearchBox":"SearchBox__6nMTe","suggest":"suggest__MbH8z","selected":"selected__fBBnT","closeButton":"closeButton__cyWHk","searchButton":"searchButton__D-vOm","blink":"blink__b9Ss2"};